module.exports = __webpack_public_path__ + "img/gallery-pic01-f1.bf525afe.jpg";